export enum RaceCourseShortForm {
    ShatinShortForm, HappyValleyShortForm, CongHuaShortForm, ShatinAllWeatherShortForm
  }
  
  // http://www.hkjc.com/english/racinginfo/racing_course.htm
  export enum RaceTrack {
    AllWeatherTrack, A, A2, A3, B, B2, B3, C, C3, NA, NA2, NB, NB2
  }
  
  export enum RaceTrackWithChangedAllWeather {
    allWeatherShort, A, A2, A3, B, B2, B3, C, C3, NA, NA2, NB, NB2
  }
  
  // http://www.hkjc.com/english/racinginfo/racing_course.htm
  export enum TrackCondition {
      TFirm, TGoodToFirm, TGood, TGoodToYielding, TYielding, TYieldingToSoft, TSoft, THeavy,
      AWWetFast, AWFast, AWGood, AWSlow, AWWetSlow, AWRainAffected, AWNormalWatering, NotAvailable
  }
  
  export enum RaceDistance1 {
      // Shatin turf distances
      STT1000, STT1200, STT1400, STT1600, STT1800, STT2000, STT2200, STT2400,
      // Happy Valley turf distances
      HVT1000, HVT1200, HVT1650, HVT1800, HVT2200, HVT2400,
      // Shatin all weather distances
      STA1200, STA1650, STA1800, STA2000, STA2400,
      // CongHua turf distances
      CHT1200, CHT1800, CHT2200
  }
  
  export enum AlertGroup {
      Horse, Jockey, Odd, Race, Rating, Run, Trackwork, Trainer
  }
  
  export enum ClientAlertGroup {
      // ClientAlertGroup: Horse = AlertGroup: Horse, Rating
      // ClientAlertGroup: Race = AlertGroup: Race, Run
      Horse, Jockey, Odd, Race, Trackwork, Trainer
  }
  
  export enum ClientDbError {
    ClientDbLog, ClientDbRecord, ClientDbRecordRollBack, ClientDbSeqError, SyncLocalDb, RecoverFromLocalDb
  }
  
  export enum PaceColor {
    Normal, Fast, Slow
  }
  
  // Finished Place: 15(DISQ), 16(DNF), 17(FE), 18(PU), 19(TNP), 20(UR), 21(VOID), 22(WR), 23(WV), 24(WVA), 25(WX), 26(WXA), 27(N/A)
  export enum ScratchedReason {
    DISQ, DNF, FE, PU, TNP, UR, VOID, WR, WV, WVA, WX, WXA, scratchedRace
  }
  


// WEBPACK FOOTER //
// ./src/util/enums.ts